export const investProgramListTableDict = {
  country: {
    en: 'Country and status',
    de: 'Land en status',
    ru: 'Страна и статус',
    tr: 'Ülke',
    es: 'País y estado',
  },
  timeRequired: {
    en: 'Time required',
    de: 'Benötigte Zeit',
    ru: 'Срок получения',
    tr: 'Gerekli Süre',
    es: 'Tiempo requerido',
  },
  investments: {
    en: 'Investments',
    de: 'Investitionen',
    ru: 'Инвестиции',
    tr: 'Yatırım',
    es: 'Inversiones',
  },
  investmentAmount: {
    en: 'Investment amount',
    de: 'Investeringsbedrag',
    ru: 'Сумма инвестиции',
    tr: 'Yatırım tutarı',
    es: 'Monto de la inversión',
  },
  no: {
    en: 'No',
    de: 'Nee',
    ru: 'Нет',
    tr: 'Hayır',
    es: 'No',
  },
  benefits: {
    en: 'Benefits',
    de: 'Vorteile',
    ru: 'Преимущества статуса',
    tr: 'Avantajlar',
    es: 'Beneficios',
  },
  investmentReturn: {
    en: 'Return of investment',
    de: 'Rendement op investering',
    ru: 'Возврат инвестиций',
    tr: 'Yatırım geri dönüşü',
    es: 'Retorno de la inversión',
  },
  minResidency: {
    en: 'Residency requirement',
    de: 'Vereiste voor verblijf',
    ru: 'Требование к проживанию',
    tr: 'İkametgah şartı',
    es: 'Requisito de residencia',
  },
};
